"use strict";
/* tslint:disable */
/* eslint-disable */
/*
Carbon

Connect external data to LLMs, no matter the source.

The version of the OpenAPI document: 1.0.0


NOTE: This file is auto generated by Konfig (https://konfigthis.com).
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilitiesApiGenerated = exports.UtilitiesApiFactory = exports.UtilitiesApiFp = exports.UtilitiesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
const FormData = require("form-data");
// @ts-ignore
const base_1 = require("../base");
const requestBeforeHook_1 = require("../requestBeforeHook");
/**
 * UtilitiesApi - axios parameter creator
 * @export
 */
const UtilitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Extracts all URLs from a webpage.   Args:     url (str): URL of the webpage  Returns:     FetchURLsResponse: A response object with a list of URLs extracted from the webpage and the webpage content.
         * @summary Fetch Urls
         * @param {string} url
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fetchUrls: (url, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'url' is not null or undefined
            (0, common_1.assertParamExists)('fetchUrls', 'url', url);
            const localVarPath = `/fetch_urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/fetch_urls',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch Urls V2
         * @param {FetchURLsRequest} fetchURLsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWebpage: (fetchURLsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fetchURLsRequest' is not null or undefined
            (0, common_1.assertParamExists)('fetchWebpage', 'fetchURLsRequest', fetchURLsRequest);
            const localVarPath = `/fetch_webpage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: fetchURLsRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/fetch_webpage',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fetchURLsRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetches english transcripts from YouTube videos.  Args:     id (str): The ID of the YouTube video.      raw (bool): Whether to return the raw transcript or not. Defaults to False.  Returns:     dict: A dictionary with the transcript of the YouTube video.
         * @summary Fetch Youtube Transcripts
         * @param {string} id
         * @param {boolean} [raw]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchYoutubeTranscripts: (id, raw, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('fetchYoutubeTranscripts', 'id', id);
            const localVarPath = `/fetch_youtube_transcript`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (raw !== undefined) {
                localVarQueryParameter['raw'] = raw;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/fetch_youtube_transcript',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves all URLs from a sitemap, which can subsequently be utilized with our `web_scrape` endpoint.  <!--Args:     url (str): URL of the sitemap  Returns:     dict: A dictionary with a list of URLs extracted from the sitemap.-->
         * @summary Sitemap
         * @param {string} url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processSitemap: (url, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'url' is not null or undefined
            (0, common_1.assertParamExists)('processSitemap', 'url', url);
            const localVarPath = `/process_sitemap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/process_sitemap',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Extracts all URLs from a sitemap and performs a web scrape on each of them.  Args:     sitemap_url (str): URL of the sitemap  Returns:     dict: A response object with the status of the scraping job message.-->
         * @summary Scrape Sitemap
         * @param {SitemapScrapeRequest} sitemapScrapeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrapeSitemap: (sitemapScrapeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sitemapScrapeRequest' is not null or undefined
            (0, common_1.assertParamExists)('scrapeSitemap', 'sitemapScrapeRequest', sitemapScrapeRequest);
            const localVarPath = `/scrape_sitemap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: sitemapScrapeRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/scrape_sitemap',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sitemapScrapeRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Conduct a web scrape on a given webpage URL. Our web scraper is fully compatible with JavaScript and supports recursion depth, enabling you to efficiently extract all content from the target website.  <!--Args:     scraping_requests (List[WebscrapeRequest]): A list of WebscrapeRequest objects.       Returns:     dict: A response object with the status of the scraping job message.-->
         * @summary Web Scrape
         * @param {Array<WebscrapeRequest>} webscrapeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrapeWeb: (webscrapeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'webscrapeRequest' is not null or undefined
            (0, common_1.assertParamExists)('scrapeWeb', 'webscrapeRequest', webscrapeRequest);
            const localVarPath = `/web_scrape`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: webscrapeRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/web_scrape',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(webscrapeRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Perform a web search and obtain a list of relevant URLs.  As an illustration, when you perform a search for “content related to MRNA,” you will receive a list of links such as the following:      - https://tomrenz.substack.com/p/mrna-and-why-it-matters      - https://www.statnews.com/2020/11/10/the-story-of-mrna-how-a-once-dismissed-idea-became-a-leading-technology-in-the-covid-vaccine-race/      - https://www.statnews.com/2022/11/16/covid-19-vaccines-were-a-success-but-mrna-still-has-a-delivery-problem/          - https://joomi.substack.com/p/were-still-being-misled-about-how  Subsequently, you can submit these links to the web_scrape endpoint in order to retrieve the content of the respective web pages.  Args:     query (str): Query to search for  Returns:     FetchURLsResponse: A response object with a list of URLs for a given search query.
         * @summary Search Urls
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUrls: (query, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            (0, common_1.assertParamExists)('searchUrls', 'query', query);
            const localVarPath = `/search_urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/search_urls',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User Web Pages
         * @param {UserWebPagesRequest} userWebPagesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userWebpages: (userWebPagesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userWebPagesRequest' is not null or undefined
            (0, common_1.assertParamExists)('userWebpages', 'userWebPagesRequest', userWebPagesRequest);
            const localVarPath = `/user_webpages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: userWebPagesRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/user_webpages',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userWebPagesRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UtilitiesApiAxiosParamCreator = UtilitiesApiAxiosParamCreator;
/**
 * UtilitiesApi - functional programming interface
 * @export
 */
const UtilitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UtilitiesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Extracts all URLs from a webpage.   Args:     url (str): URL of the webpage  Returns:     FetchURLsResponse: A response object with a list of URLs extracted from the webpage and the webpage content.
         * @summary Fetch Urls
         * @param {UtilitiesApiFetchUrlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fetchUrls(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchUrls(requestParameters.url, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch Urls V2
         * @param {UtilitiesApiFetchWebpageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWebpage(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const fetchURLsRequest = {
                    url: requestParameters.url
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchWebpage(fetchURLsRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetches english transcripts from YouTube videos.  Args:     id (str): The ID of the YouTube video.      raw (bool): Whether to return the raw transcript or not. Defaults to False.  Returns:     dict: A dictionary with the transcript of the YouTube video.
         * @summary Fetch Youtube Transcripts
         * @param {UtilitiesApiFetchYoutubeTranscriptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchYoutubeTranscripts(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchYoutubeTranscripts(requestParameters.id, requestParameters.raw, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves all URLs from a sitemap, which can subsequently be utilized with our `web_scrape` endpoint.  <!--Args:     url (str): URL of the sitemap  Returns:     dict: A dictionary with a list of URLs extracted from the sitemap.-->
         * @summary Sitemap
         * @param {UtilitiesApiProcessSitemapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processSitemap(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.processSitemap(requestParameters.url, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Extracts all URLs from a sitemap and performs a web scrape on each of them.  Args:     sitemap_url (str): URL of the sitemap  Returns:     dict: A response object with the status of the scraping job message.-->
         * @summary Scrape Sitemap
         * @param {UtilitiesApiScrapeSitemapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrapeSitemap(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const sitemapScrapeRequest = {
                    tags: requestParameters.tags,
                    url: requestParameters.url,
                    max_pages_to_scrape: requestParameters.max_pages_to_scrape,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    enable_auto_sync: requestParameters.enable_auto_sync,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    html_tags_to_skip: requestParameters.html_tags_to_skip,
                    css_classes_to_skip: requestParameters.css_classes_to_skip,
                    css_selectors_to_skip: requestParameters.css_selectors_to_skip,
                    embedding_model: requestParameters.embedding_model,
                    url_paths_to_include: requestParameters.url_paths_to_include,
                    url_paths_to_exclude: requestParameters.url_paths_to_exclude,
                    urls_to_scrape: requestParameters.urls_to_scrape,
                    download_css_and_media: requestParameters.download_css_and_media,
                    generate_chunks_only: requestParameters.generate_chunks_only,
                    store_file_only: requestParameters.store_file_only,
                    use_premium_proxies: requestParameters.use_premium_proxies
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scrapeSitemap(sitemapScrapeRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Conduct a web scrape on a given webpage URL. Our web scraper is fully compatible with JavaScript and supports recursion depth, enabling you to efficiently extract all content from the target website.  <!--Args:     scraping_requests (List[WebscrapeRequest]): A list of WebscrapeRequest objects.       Returns:     dict: A response object with the status of the scraping job message.-->
         * @summary Web Scrape
         * @param {UtilitiesApiScrapeWebRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrapeWeb(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const webscrapeRequest = requestParameters;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scrapeWeb(webscrapeRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Perform a web search and obtain a list of relevant URLs.  As an illustration, when you perform a search for “content related to MRNA,” you will receive a list of links such as the following:      - https://tomrenz.substack.com/p/mrna-and-why-it-matters      - https://www.statnews.com/2020/11/10/the-story-of-mrna-how-a-once-dismissed-idea-became-a-leading-technology-in-the-covid-vaccine-race/      - https://www.statnews.com/2022/11/16/covid-19-vaccines-were-a-success-but-mrna-still-has-a-delivery-problem/          - https://joomi.substack.com/p/were-still-being-misled-about-how  Subsequently, you can submit these links to the web_scrape endpoint in order to retrieve the content of the respective web pages.  Args:     query (str): Query to search for  Returns:     FetchURLsResponse: A response object with a list of URLs for a given search query.
         * @summary Search Urls
         * @param {UtilitiesApiSearchUrlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUrls(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchUrls(requestParameters.query, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User Web Pages
         * @param {UtilitiesApiUserWebpagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userWebpages(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const userWebPagesRequest = {
                    filters: requestParameters.filters,
                    pagination: requestParameters.pagination,
                    order_by: requestParameters.order_by,
                    order_dir: requestParameters.order_dir
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userWebpages(userWebPagesRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UtilitiesApiFp = UtilitiesApiFp;
/**
 * UtilitiesApi - factory interface
 * @export
 */
const UtilitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UtilitiesApiFp)(configuration);
    return {
        /**
         * Extracts all URLs from a webpage.   Args:     url (str): URL of the webpage  Returns:     FetchURLsResponse: A response object with a list of URLs extracted from the webpage and the webpage content.
         * @summary Fetch Urls
         * @param {UtilitiesApiFetchUrlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fetchUrls(requestParameters, options) {
            return localVarFp.fetchUrls(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch Urls V2
         * @param {UtilitiesApiFetchWebpageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWebpage(requestParameters, options) {
            return localVarFp.fetchWebpage(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches english transcripts from YouTube videos.  Args:     id (str): The ID of the YouTube video.      raw (bool): Whether to return the raw transcript or not. Defaults to False.  Returns:     dict: A dictionary with the transcript of the YouTube video.
         * @summary Fetch Youtube Transcripts
         * @param {UtilitiesApiFetchYoutubeTranscriptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchYoutubeTranscripts(requestParameters, options) {
            return localVarFp.fetchYoutubeTranscripts(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all URLs from a sitemap, which can subsequently be utilized with our `web_scrape` endpoint.  <!--Args:     url (str): URL of the sitemap  Returns:     dict: A dictionary with a list of URLs extracted from the sitemap.-->
         * @summary Sitemap
         * @param {UtilitiesApiProcessSitemapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processSitemap(requestParameters, options) {
            return localVarFp.processSitemap(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Extracts all URLs from a sitemap and performs a web scrape on each of them.  Args:     sitemap_url (str): URL of the sitemap  Returns:     dict: A response object with the status of the scraping job message.-->
         * @summary Scrape Sitemap
         * @param {UtilitiesApiScrapeSitemapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrapeSitemap(requestParameters, options) {
            return localVarFp.scrapeSitemap(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Conduct a web scrape on a given webpage URL. Our web scraper is fully compatible with JavaScript and supports recursion depth, enabling you to efficiently extract all content from the target website.  <!--Args:     scraping_requests (List[WebscrapeRequest]): A list of WebscrapeRequest objects.       Returns:     dict: A response object with the status of the scraping job message.-->
         * @summary Web Scrape
         * @param {UtilitiesApiScrapeWebRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrapeWeb(requestParameters, options) {
            return localVarFp.scrapeWeb(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Perform a web search and obtain a list of relevant URLs.  As an illustration, when you perform a search for “content related to MRNA,” you will receive a list of links such as the following:      - https://tomrenz.substack.com/p/mrna-and-why-it-matters      - https://www.statnews.com/2020/11/10/the-story-of-mrna-how-a-once-dismissed-idea-became-a-leading-technology-in-the-covid-vaccine-race/      - https://www.statnews.com/2022/11/16/covid-19-vaccines-were-a-success-but-mrna-still-has-a-delivery-problem/          - https://joomi.substack.com/p/were-still-being-misled-about-how  Subsequently, you can submit these links to the web_scrape endpoint in order to retrieve the content of the respective web pages.  Args:     query (str): Query to search for  Returns:     FetchURLsResponse: A response object with a list of URLs for a given search query.
         * @summary Search Urls
         * @param {UtilitiesApiSearchUrlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUrls(requestParameters, options) {
            return localVarFp.searchUrls(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User Web Pages
         * @param {UtilitiesApiUserWebpagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userWebpages(requestParameters, options) {
            return localVarFp.userWebpages(requestParameters, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UtilitiesApiFactory = UtilitiesApiFactory;
/**
 * UtilitiesApiGenerated - object-oriented interface
 * @export
 * @class UtilitiesApiGenerated
 * @extends {BaseAPI}
 */
class UtilitiesApiGenerated extends base_1.BaseAPI {
    /**
     * Extracts all URLs from a webpage.   Args:     url (str): URL of the webpage  Returns:     FetchURLsResponse: A response object with a list of URLs extracted from the webpage and the webpage content.
     * @summary Fetch Urls
     * @param {UtilitiesApiFetchUrlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    fetchUrls(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).fetchUrls(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch Urls V2
     * @param {UtilitiesApiFetchWebpageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    fetchWebpage(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).fetchWebpage(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetches english transcripts from YouTube videos.  Args:     id (str): The ID of the YouTube video.      raw (bool): Whether to return the raw transcript or not. Defaults to False.  Returns:     dict: A dictionary with the transcript of the YouTube video.
     * @summary Fetch Youtube Transcripts
     * @param {UtilitiesApiFetchYoutubeTranscriptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    fetchYoutubeTranscripts(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).fetchYoutubeTranscripts(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves all URLs from a sitemap, which can subsequently be utilized with our `web_scrape` endpoint.  <!--Args:     url (str): URL of the sitemap  Returns:     dict: A dictionary with a list of URLs extracted from the sitemap.-->
     * @summary Sitemap
     * @param {UtilitiesApiProcessSitemapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    processSitemap(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).processSitemap(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Extracts all URLs from a sitemap and performs a web scrape on each of them.  Args:     sitemap_url (str): URL of the sitemap  Returns:     dict: A response object with the status of the scraping job message.-->
     * @summary Scrape Sitemap
     * @param {UtilitiesApiScrapeSitemapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    scrapeSitemap(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).scrapeSitemap(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Conduct a web scrape on a given webpage URL. Our web scraper is fully compatible with JavaScript and supports recursion depth, enabling you to efficiently extract all content from the target website.  <!--Args:     scraping_requests (List[WebscrapeRequest]): A list of WebscrapeRequest objects.       Returns:     dict: A response object with the status of the scraping job message.-->
     * @summary Web Scrape
     * @param {UtilitiesApiScrapeWebRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    scrapeWeb(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).scrapeWeb(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Perform a web search and obtain a list of relevant URLs.  As an illustration, when you perform a search for “content related to MRNA,” you will receive a list of links such as the following:      - https://tomrenz.substack.com/p/mrna-and-why-it-matters      - https://www.statnews.com/2020/11/10/the-story-of-mrna-how-a-once-dismissed-idea-became-a-leading-technology-in-the-covid-vaccine-race/      - https://www.statnews.com/2022/11/16/covid-19-vaccines-were-a-success-but-mrna-still-has-a-delivery-problem/          - https://joomi.substack.com/p/were-still-being-misled-about-how  Subsequently, you can submit these links to the web_scrape endpoint in order to retrieve the content of the respective web pages.  Args:     query (str): Query to search for  Returns:     FetchURLsResponse: A response object with a list of URLs for a given search query.
     * @summary Search Urls
     * @param {UtilitiesApiSearchUrlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    searchUrls(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).searchUrls(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User Web Pages
     * @param {UtilitiesApiUserWebpagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiGenerated
     */
    userWebpages(requestParameters, options) {
        return (0, exports.UtilitiesApiFp)(this.configuration).userWebpages(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UtilitiesApiGenerated = UtilitiesApiGenerated;
